import { Col, Divider, Flex, Row, Image } from 'antd';
import { useSelector } from 'react-redux';
import { selectMachine } from '../../../../slices/machines';
import { Section, SectionTitle } from './styles';
import LineItem from '../../../../components/lineItem';
import { useTranslation } from 'react-i18next';
import NotFound from '../../../../components/notFound';
import Tab from '../../../../components/tab';
import dayjs from 'dayjs';
import { ImageContainer } from '../../../../styles/commonStyles';
import LogsTab from './logsTab';

const tabs = [
  {
    id: 1,
    title: 'Status',
    component: <NotFound showButton={false} />,
  },
  {
    id: 2,
    title: 'Trending',
    component: <NotFound showButton={false} />,
  },
  {
    id: 3,
    title: 'Logs',
    component: <NotFound showButton={false} />,
  },
];

const MachineDetails = () => {
  const { t } = useTranslation();

  const machine = useSelector(selectMachine);

  const updatedTabs = tabs.map((tab) =>
    tab.id === 3
      ? {
          ...tab,
          component: <LogsTab machineId={machine?.machineID?.toString()} />,
        }
      : tab
  );

  return (
    <Flex vertical gap={4} style={{ backgroundColor: '#f6f6f6' }}>
      <Section vertical gap={13} style={{}}>
        <SectionTitle>{t('basic_information')}</SectionTitle>
        <Row gutter={[40, 16]}>
          <Col span={8}>
            <ImageContainer
              style={{
                width: '60%',
                minHeight: '60%',
              }}
            >
              <Image
                src={machine?.images?.[0]?.url}
                preview={!!machine?.images?.[0]?.url}
                fallback="/placeholder.png"
              />
            </ImageContainer>
          </Col>
          <Col span={16}>
            <Row gutter={[40, 16]}>
              <Col span={12}>
                <LineItem label={t('machine_name')} value={machine?.name} />
              </Col>
              <Col span={12}>
                <LineItem label={t('alias')} value={machine?.alias} />
              </Col>
              <Col span={12}>
                <LineItem
                  label={t('serial_number')}
                  value={machine?.serialNumber}
                />
              </Col>
              <Col span={12}>
                <LineItem
                  label={t('manufacturer')}
                  value={machine?.manufacturer}
                />
              </Col>
              <Col span={12}>
                <LineItem label={t('location')} value={machine?.location} />
              </Col>
              <Col span={12}>
                <LineItem
                  label={t('unique_id')}
                  value={machine?.serviceNumber}
                />
              </Col>
              <Col span={12}>
                <LineItem
                  label={t('construction_date')}
                  value={
                    machine?.constructionDate &&
                    dayjs(machine?.constructionDate).format('DD/MM/YYYY')
                  }
                />
              </Col>
              <Col span={12}>
                <LineItem
                  label={t('acceptance_date')}
                  value={
                    machine?.acceptanceDate &&
                    dayjs(machine?.acceptanceDate).format('DD/MM/YYYY')
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <SectionTitle>{t('knowledge_base')}</SectionTitle>
        <Row gutter={[40, 16]}>
          <Col span={8}>
            <LineItem label={t('template')} value={machine?.templateName} />
          </Col>
          <Col span={8}>
            <LineItem label={t('machine_type')} value={machine?.type} />
          </Col>
          <Col span={8}>
            <LineItem label={t('tag')} />
          </Col>
        </Row>
      </Section>
      <Tab tabs={updatedTabs}></Tab>
    </Flex>
  );
};

export default MachineDetails;
